import React, { useState, useEffect } from "react";
import "./index.scoped.css";
import { CASINO_VIDEO, getOddForEntity, setBet } from "./CasinoGeneric";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";
import {
  getCasinoBetsAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import PlaceBet from "./components/PlaceBet";
import PlacedBet from "./components/PlacedBet";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import { io } from "socket.io-client";
import { useSelector } from "react-redux";
import CasinoBetModal from "./CasinoBetModal";
import { fetchThirtyTwoCardStack } from "../../redux/features/thirtyTwoCardGameSlice";
import { API } from "../../service/API";
import CasinoPlacedBet from "./components/CasinoPlaceBet";

export default function Baccarat2() {
  const GAME_ID = "BACCARAT2";
  const VIDEO_ID = CASINO_VIDEO.baccarat2;
  const dispatch = useDispatch();
  const id = 23;
  const { user } = useSelector((state) => state.auth);
  const token = user?.token;
  const uid = user.data.resultid;
  console.log("id1", user);
  const [name, setName] = useState("");
  const [results, setResults] = useState([]);
  const [midRound, setMidRound] = useState(0);
  const [showresultModal, setShowresultModal] = useState(false);
  const [trophy, setTrophy] = useState("");
  const [betIndex, setBetIndex] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [realTime, setRealTimeData] = useState(false);
  const [reqRes, setreqRes] = useState({ t1: [], t2: [] });
  const [casinoGameResult, setCasinoGameResult] = useState([]);
  const [betDetails, setbetDetails] = useState({});
  const [history, setHistory] = useState([]);

  const { thirtyTwoCardStack } = useSelector(
    (state) => state.thirtyTwoCardGameStack
  );

  const CasinoGameResult_API = async (mid) => {
    try {
      const response = await API.post("/GetCasinoGameResultData", {
        mid: mid,
        gameid: id,
      });
      console.log("CasinoGameResult 32:", response);
      setCasinoGameResult(response.data.data[0]);
    } catch (error) {
      console.error("Error CasinoGameResult_API", error);
    }
  };

  const SOCKET_URL = "https://dreamwin-socket.nakshtech.info/";

  useEffect(() => {
    const cricketMatchesSocket = io(SOCKET_URL);
    cricketMatchesSocket.emit("GetCasinoGameSocket", id);

    cricketMatchesSocket.on("GetCasinoGameSocket_FromAPI", (data) => {
      // console.log("TeenPatti socket1==>", data);
      if (data && data.length > 0) {
        const parsedData = data.map((item) => ({
          ...item,
          reqResponse: JSON.parse(item.reqResponse),
          resultUrlResponse: JSON.parse(item.resultUrlResponse),
        }));

        console.log("baccarat2", parsedData[0].reqResponse);
        setResults(parsedData[0].reqResponse);
        setreqRes(parsedData[0].reqResponse);
        setName(parsedData[0].name);
      }
    });

    return () => {
      cricketMatchesSocket.disconnect();
    };
  }, []);
  const handleModalPopUp = () => {
    setShowModal(!showModal);
  };

  const handleModal = (value, nat, no) => {
    setbetDetails({
      ...betDetails,
      gameid: id,
      multipler: value,
      period: 0,
      nat: nat,
      number: no,
    });
    handleModalPopUp(true);

    setRealTimeData(true);
  };

  function checkValid() {
    if (showModal && realTime) {
      let filteredData = reqRes?.data?.data?.t2?.filter(
        (item) => item.nat === betDetails.nat
      );
      // console.log("filter", filteredData, betDetails);
      filteredData[0]?.gstatus !== "0" &&
      betDetails?.nat === filteredData[0]?.nat &&
      betDetails?.multipler === filteredData[0]?.b1
        ? setRealTimeData(true)
        : setRealTimeData(false);
    }
  }

  useEffect(() => {
    checkValid();
  }, [showModal, realTime, reqRes?.data?.data?.t2, betDetails]);

  useEffect(() => {
    console.log("id2", id);

    const cricketMatchesSocket = io(SOCKET_URL);
    cricketMatchesSocket.emit("GetCasinoBetReportSocket", uid, id);

    cricketMatchesSocket.on("GetCasinoBetReportSocket_FromAPI", (data) => {
      // console.log("===Get", data);
      if (data && data[0].length > 0) {
        setHistory(data[0]);
      }
    });

    return () => {
      cricketMatchesSocket.disconnect();
    };
  }, []);

  async function ResultScheduler_API() {
    try {
      let res = await API.post(
        "/Schulder_7CareGameLive",
        {
          gameid: id,
          username: uid,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      // console.log("scheduler res", res.data);
    } catch (e) {
      console.log("Error", e);
    }
  }

  useEffect(() => {
    ResultScheduler_API();
    dispatch(fetchThirtyTwoCardStack({ uid, gameId: id, token }));
  }, [dispatch, reqRes?.data?.data?.t1[0]?.mid]);


  // const findCardImage = (cardId) => {
  //   const card = card52War.find((card) => card.id === cardId);
  //   return card ? card.src : null;
  // };

  // const parseCardData = (cardData) => {
  //   return cardData?.split(",").map((card) => {
  //     const cardName = card.trim(); // Extract card name and trim any whitespace
  //     return cardName;
  //   });
  // };

  // const arrayData = parseCardData(reqRes?.data?.data?.t1[0]?.desc ?? "");
  // console.log("arr", arrayData);

  // const casinoData = useQuery(
  //   "getCasinoOdds",
  //   () => getCasinoOddsAPI(GAME_ID),
  //   {
  //     refetchInterval: 800,
  //   }
  // );
  // const lastTenResultData = useQuery(
  //   "getResult",
  //   () => getCasinoLastTenResultAPI(GAME_ID),
  //   {
  //     refetchInterval: 1500,
  //   }
  // );
  // const casinoBets = useQuery("casinoBets", () => getCasinoBetsAPI(GAME_ID), {
  //   refetchInterval: 2500,
  // });
  const [selectedTab, setSelectedTab] = useState("game");

  return (
    <div className="center-main-container casino-page ng-tns-c3502172659-7 ng-star-inserted">
      <div className="center-container ng-tns-c3502172659-7">
        <div className="casino-page-container ng-tns-c3502172659-7 baccarat">
          <div className="casino-title-header-mobile d-xl-none ng-tns-c3502172659-5">
            <ul className="nav nav-tabs menu-tabs ng-tns-c3502172659-5">
              <li
                onClick={() => setSelectedTab("game")}
                className="nav-item ng-tns-c3502172659-5"
              >
                <div
                  className={`ng-tns-c3502172659-5 
                     
                      nav-link`}
                >
                  Game
                </div>
              </li>
              <li
                onClick={() => setSelectedTab("placedBet")}
                className="nav-item ng-tns-c3502172659-5"
              >
                <div
                  className={`ng-tns-c3502172659-5 
                     
                      nav-link`}
                >
                  {" "}
                  Placed Bet ({history?.length})
                </div>
              </li>
            </ul>
            <div className="pe-2 ng-tns-c3502172659-5">
              <span className="casino-rid ng-tns-c3502172659-5">
                <a className="d-block ng-tns-c3502172659-5">
                  <small className="ng-tns-c3502172659-5">Rules</small>
                </a>{" "}
                Round ID: {reqRes?.data?.data?.t1[0]?.mid || 0.0}
                <span className="ng-tns-c3502172659-5 ng-star-inserted">
                  {/* {casinoData?.data?.response?.marketId} */}
                </span>
              </span>
            </div>
          </div>
          <div className="casino-header ng-tns-c3502172659-7">
            <span className="casino-name ng-tns-c3502172659-7">
              {" "}
              Baccarat2
              <a className="ms-1 d-xl-inline d-none ng-tns-c3502172659-7">
                <small className="ng-tns-c3502172659-7">Rules</small>
              </a>
            </span>
            <span className="casino-rid d-none d-xl-inline-block ng-tns-c3502172659-7">
              <small className="ng-tns-c3502172659-7">
                Round ID: {reqRes?.data?.data?.t1[0]?.mid || 0.0}
                <span className="ng-tns-c3502172659-7 ng-star-inserted">
                  {/* {casinoData?.data?.response?.marketId} */}
                </span>
              </small>
              <span className="ng-tns-c3502172659-7 ng-star-inserted">
                {" "}
                | Min: 100 | Max: 100000
              </span>
            </span>
          </div>
       {selectedTab === "game" ? ( 
          <div className="ng-tns-c3502172659-7 ng-star-inserted">
            <div className="casino-video ng-tns-c3502172659-7">
              <div className="video-box-container ">
                <div className="casino-video-box  ng-star-inserted">
                  {/* <CasinoVideo id={VIDEO_ID} /> */}
                  <iframe
                    height="100%"
                    width="100%"
                    src={`https://battlemoney.live/iframe/${id}`}
                    title=""
                  />
                </div>
              </div>
              <div className="ng-tns-c3502172659-7 ng-star-inserted" />

              {/* <Timer value={casinoData?.data?.response?.autoTime} /> */}
              <Timer value={reqRes?.data?.data?.t1[0]?.autotime || 0} />
            </div>

            <div className="casino-detail ng-tns-c3502172659-7">
              <div className="casino-detail ng-tns-c3502172659-7 ng-star-inserted">
                <div className="casino-table ng-tns-c3502172659-7">
                  <div className="casino-table-full-box ng-tns-c3502172659-7">
                    <app-pie-chart
                      className="ng-tns-c3502172659-7"
                      _nghost-ng-c594452701
                    >
                      <div className="desktop-graph d-lg-inline d-none">
                        <div className="baccarat-graph text-center">
                          <h4>
                            <b> Statistics </b>
                          </h4>
                          <div style={{ height: "160px", width: "100%" }}>
                            <div
                              id="reactgooglegraph-2"
                              style={{ height: "160px", width: "100%" }}
                            >
                              <div style={{ position: "relative" }}>
                                <div id="chart">
                                  {/*  <apx-chart >
                                        <div style={{ minHeight: "225.7px" }}>
                                          <div
                                            id="apexcharts1q1isv5a"
                                            className="apexcharts-canvas apexcharts1q1isv5a apexcharts-theme-light"
                                            style={{
                                              width: "270px",
                                              height: "225.7px",
                                            }}
                                          >
                                            <svg
                                              id="SvgjsSvg5024"
                                              width={270}
                                              height="225.70000000000002"
                                              xmlns="http://www.w3.org/2000/svg"
                                              version="1.1"
                                              xmlnsXlink="http://www.w3.org/1999/xlink"
                                              xmlns:svgjs="http://svgjs.dev"
                                              className="apexcharts-svg"
                                              xmlns:data="ApexChartsNS"
                                              transform="translate(0, 0)"
                                              style={{
                                                background: "transparent",
                                              }}
                                            >
                                              <foreignObject
                                                x={0}
                                                y={0}
                                                width={270}
                                                height="225.70000000000002"
                                              >
                                                <div
                                                  className="apexcharts-legend apexcharts-align-center apx-legend-position-right"
                                                  xmlns="http://www.w3.org/1999/xhtml"
                                                  style={{
                                                    position: "absolute",
                                                    left: "auto",
                                                    top: "24px",
                                                    right: "5px",
                                                  }}
                                                >
                                                  <div
                                                    className="apexcharts-legend-series"
                                                    rel={1}
                                                    seriesname="Player"
                                                    data:collapsed="false"
                                                    style={{
                                                      margin: "2px 5px",
                                                    }}
                                                  >
                                                    <span
                                                      className="apexcharts-legend-marker"
                                                      rel={1}
                                                      data:collapsed="false"
                                                      style={{
                                                        background:
                                                          "rgb(8, 108, 184) !important",
                                                        color:
                                                          "rgb(8, 108, 184)",
                                                        height: "12px",
                                                        width: "12px",
                                                        left: "0px",
                                                        top: "0px",
                                                        borderWidth: "0px",
                                                        borderColor:
                                                          "rgb(255, 255, 255)",
                                                        borderRadius: "12px",
                                                      }}
                                                    />
                                                    <span
                                                      className="apexcharts-legend-text"
                                                      rel={1}
                                                      i={0}
                                                      data:default-text="Player"
                                                      data:collapsed="false"
                                                      style={{
                                                        color:
                                                          "rgb(55, 61, 63)",
                                                        fontSize: "12px",
                                                        fontWeight: 400,
                                                        fontFamily:
                                                          "Helvetica, Arial, sans-serif",
                                                      }}
                                                    >
                                                      Player
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="apexcharts-legend-series"
                                                    rel={2}
                                                    seriesname="Banker"
                                                    data:collapsed="false"
                                                    style={{
                                                      margin: "2px 5px",
                                                    }}
                                                  >
                                                    <span
                                                      className="apexcharts-legend-marker"
                                                      rel={2}
                                                      data:collapsed="false"
                                                      style={{
                                                        background:
                                                          "rgb(174, 33, 48) !important",
                                                        color:
                                                          "rgb(174, 33, 48)",
                                                        height: "12px",
                                                        width: "12px",
                                                        left: "0px",
                                                        top: "0px",
                                                        borderWidth: "0px",
                                                        borderColor:
                                                          "rgb(255, 255, 255)",
                                                        borderRadius: "12px",
                                                      }}
                                                    />
                                                    <span
                                                      className="apexcharts-legend-text"
                                                      rel={2}
                                                      i={1}
                                                      data:default-text="Banker"
                                                      data:collapsed="false"
                                                      style={{
                                                        color:
                                                          "rgb(55, 61, 63)",
                                                        fontSize: "12px",
                                                        fontWeight: 400,
                                                        fontFamily:
                                                          "Helvetica, Arial, sans-serif",
                                                      }}
                                                    >
                                                      Banker
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="apexcharts-legend-series"
                                                    rel={3}
                                                    seriesname="Tie"
                                                    data:collapsed="false"
                                                    style={{
                                                      margin: "2px 5px",
                                                    }}
                                                  >
                                                    <span
                                                      className="apexcharts-legend-marker"
                                                      rel={3}
                                                      data:collapsed="false"
                                                      style={{
                                                        background:
                                                          "rgb(39, 149, 50) !important",
                                                        color:
                                                          "rgb(39, 149, 50)",
                                                        height: "12px",
                                                        width: "12px",
                                                        left: "0px",
                                                        top: "0px",
                                                        borderWidth: "0px",
                                                        borderColor:
                                                          "rgb(255, 255, 255)",
                                                        borderRadius: "12px",
                                                      }}
                                                    />
                                                    <span
                                                      className="apexcharts-legend-text"
                                                      rel={3}
                                                      i={2}
                                                      data:default-text="Tie"
                                                      data:collapsed="false"
                                                      style={{
                                                        color:
                                                          "rgb(55, 61, 63)",
                                                        fontSize: "12px",
                                                        fontWeight: 400,
                                                        fontFamily:
                                                          "Helvetica, Arial, sans-serif",
                                                      }}
                                                    >
                                                      Tie
                                                    </span>
                                                  </div>
                                                </div>
                                                <style
                                                  type="text/css"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      "\t\n    \t\n      .apexcharts-legend {\t\n        display: flex;\t\n        overflow: auto;\t\n        padding: 0 10px;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {\t\n        flex-wrap: wrap\t\n      }\t\n      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\t\n        flex-direction: column;\t\n        bottom: 0;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\t\n        justify-content: flex-start;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {\t\n        justify-content: center;  \t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {\t\n        justify-content: flex-end;\t\n      }\t\n      .apexcharts-legend-series {\t\n        cursor: pointer;\t\n        line-height: normal;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom .apexcharts-legend-series, .apexcharts-legend.apx-legend-position-top .apexcharts-legend-series{\t\n        display: flex;\t\n        align-items: center;\t\n      }\t\n      .apexcharts-legend-text {\t\n        position: relative;\t\n        font-size: 14px;\t\n      }\t\n      .apexcharts-legend-text *, .apexcharts-legend-marker * {\t\n        pointer-events: none;\t\n      }\t\n      .apexcharts-legend-marker {\t\n        position: relative;\t\n        display: inline-block;\t\n        cursor: pointer;\t\n        margin-right: 3px;\t\n        border-style: solid;\n      }\t\n      \t\n      .apexcharts-legend.apexcharts-align-right .apexcharts-legend-series, .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{\t\n        display: inline-block;\t\n      }\t\n      .apexcharts-legend-series.apexcharts-no-click {\t\n        cursor: auto;\t\n      }\t\n      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {\t\n        display: none !important;\t\n      }\t\n      .apexcharts-inactive-legend {\t\n        opacity: 0.45;\t\n      }",
                                                  }}
                                                />
                                              </foreignObject>
                                              <g
                                                id="SvgjsG5026"
                                                className="apexcharts-inner apexcharts-graphical"
                                                transform="translate(22, 0)"
                                              >
                                                <defs id="SvgjsDefs5025">
                                                  <clipPath id="gridRectMask1q1isv5a">
                                                    <rect
                                                      id="SvgjsRect5027"
                                                      width={229}
                                                      height={247}
                                                      x={-3}
                                                      y={-1}
                                                      rx={0}
                                                      ry={0}
                                                      opacity={1}
                                                      strokeWidth={0}
                                                      stroke="none"
                                                      strokeDasharray={0}
                                                      fill="#fff"
                                                    />
                                                  </clipPath>
                                                  <clipPath id="forecastMask1q1isv5a" />
                                                  <clipPath id="nonForecastMask1q1isv5a" />
                                                  <clipPath id="gridRectMarkerMask1q1isv5a">
                                                    <rect
                                                      id="SvgjsRect5028"
                                                      width={227}
                                                      height={249}
                                                      x={-2}
                                                      y={-2}
                                                      rx={0}
                                                      ry={0}
                                                      opacity={1}
                                                      strokeWidth={0}
                                                      stroke="none"
                                                      strokeDasharray={0}
                                                      fill="#fff"
                                                    />
                                                  </clipPath>
                                                  <filter
                                                    id="SvgjsFilter5036"
                                                    filterUnits="userSpaceOnUse"
                                                    width="200%"
                                                    height="200%"
                                                    x="-50%"
                                                    y="-50%"
                                                  >
                                                    <feFlood
                                                      id="SvgjsFeFlood5037"
                                                      floodColor="#000000"
                                                      floodOpacity="0.45"
                                                      result="SvgjsFeFlood5037Out"
                                                      in="SourceGraphic"
                                                    />
                                                    <feComposite
                                                      id="SvgjsFeComposite5038"
                                                      in="SvgjsFeFlood5037Out"
                                                      in2="SourceAlpha"
                                                      operator="in"
                                                      result="SvgjsFeComposite5038Out"
                                                    />
                                                    <feOffset
                                                      id="SvgjsFeOffset5039"
                                                      dx={1}
                                                      dy={1}
                                                      result="SvgjsFeOffset5039Out"
                                                      in="SvgjsFeComposite5038Out"
                                                    />
                                                    <feGaussianBlur
                                                      id="SvgjsFeGaussianBlur5040"
                                                      stdDeviation={1}
                                                      result="SvgjsFeGaussianBlur5040Out"
                                                      in="SvgjsFeOffset5039Out"
                                                    />
                                                    <feMerge
                                                      id="SvgjsFeMerge5041"
                                                      result="SvgjsFeMerge5041Out"
                                                      in="SourceGraphic"
                                                    >
                                                      <feMergeNode
                                                        id="SvgjsFeMergeNode5042"
                                                        in="SvgjsFeGaussianBlur5040Out"
                                                      />
                                                      <feMergeNode
                                                        id="SvgjsFeMergeNode5043"
                                                        in="[object Arguments]"
                                                      />
                                                    </feMerge>
                                                    <feBlend
                                                      id="SvgjsFeBlend5044"
                                                      in="SourceGraphic"
                                                      in2="SvgjsFeMerge5041Out"
                                                      mode="normal"
                                                      result="SvgjsFeBlend5044Out"
                                                    />
                                                  </filter>
                                                  <filter
                                                    id="SvgjsFilter5049"
                                                    filterUnits="userSpaceOnUse"
                                                    width="200%"
                                                    height="200%"
                                                    x="-50%"
                                                    y="-50%"
                                                  >
                                                    <feFlood
                                                      id="SvgjsFeFlood5050"
                                                      floodColor="#000000"
                                                      floodOpacity="0.45"
                                                      result="SvgjsFeFlood5050Out"
                                                      in="SourceGraphic"
                                                    />
                                                    <feComposite
                                                      id="SvgjsFeComposite5051"
                                                      in="SvgjsFeFlood5050Out"
                                                      in2="SourceAlpha"
                                                      operator="in"
                                                      result="SvgjsFeComposite5051Out"
                                                    />
                                                    <feOffset
                                                      id="SvgjsFeOffset5052"
                                                      dx={1}
                                                      dy={1}
                                                      result="SvgjsFeOffset5052Out"
                                                      in="SvgjsFeComposite5051Out"
                                                    />
                                                    <feGaussianBlur
                                                      id="SvgjsFeGaussianBlur5053"
                                                      stdDeviation={1}
                                                      result="SvgjsFeGaussianBlur5053Out"
                                                      in="SvgjsFeOffset5052Out"
                                                    />
                                                    <feMerge
                                                      id="SvgjsFeMerge5054"
                                                      result="SvgjsFeMerge5054Out"
                                                      in="SourceGraphic"
                                                    >
                                                      <feMergeNode
                                                        id="SvgjsFeMergeNode5055"
                                                        in="SvgjsFeGaussianBlur5053Out"
                                                      />
                                                      <feMergeNode
                                                        id="SvgjsFeMergeNode5056"
                                                        in="[object Arguments]"
                                                      />
                                                    </feMerge>
                                                    <feBlend
                                                      id="SvgjsFeBlend5057"
                                                      in="SourceGraphic"
                                                      in2="SvgjsFeMerge5054Out"
                                                      mode="normal"
                                                      result="SvgjsFeBlend5057Out"
                                                    />
                                                  </filter>
                                                  <filter
                                                    id="SvgjsFilter5062"
                                                    filterUnits="userSpaceOnUse"
                                                    width="200%"
                                                    height="200%"
                                                    x="-50%"
                                                    y="-50%"
                                                  >
                                                    <feFlood
                                                      id="SvgjsFeFlood5063"
                                                      floodColor="#000000"
                                                      floodOpacity="0.45"
                                                      result="SvgjsFeFlood5063Out"
                                                      in="SourceGraphic"
                                                    />
                                                    <feComposite
                                                      id="SvgjsFeComposite5064"
                                                      in="SvgjsFeFlood5063Out"
                                                      in2="SourceAlpha"
                                                      operator="in"
                                                      result="SvgjsFeComposite5064Out"
                                                    />
                                                    <feOffset
                                                      id="SvgjsFeOffset5065"
                                                      dx={1}
                                                      dy={1}
                                                      result="SvgjsFeOffset5065Out"
                                                      in="SvgjsFeComposite5064Out"
                                                    />
                                                    <feGaussianBlur
                                                      id="SvgjsFeGaussianBlur5066"
                                                      stdDeviation={1}
                                                      result="SvgjsFeGaussianBlur5066Out"
                                                      in="SvgjsFeOffset5065Out"
                                                    />
                                                    <feMerge
                                                      id="SvgjsFeMerge5067"
                                                      result="SvgjsFeMerge5067Out"
                                                      in="SourceGraphic"
                                                    >
                                                      <feMergeNode
                                                        id="SvgjsFeMergeNode5068"
                                                        in="SvgjsFeGaussianBlur5066Out"
                                                      />
                                                      <feMergeNode
                                                        id="SvgjsFeMergeNode5069"
                                                        in="[object Arguments]"
                                                      />
                                                    </feMerge>
                                                    <feBlend
                                                      id="SvgjsFeBlend5070"
                                                      in="SourceGraphic"
                                                      in2="SvgjsFeMerge5067Out"
                                                      mode="normal"
                                                      result="SvgjsFeBlend5070Out"
                                                    />
                                                  </filter>
                                                </defs>
                                                <g
                                                  id="SvgjsG5029"
                                                  className="apexcharts-pie"
                                                >
                                                  <g
                                                    id="SvgjsG5030"
                                                    transform="translate(0, 0) scale(1)"
                                                  >
                                                    <g
                                                      id="SvgjsG5031"
                                                      className="apexcharts-slices"
                                                    >
                                                      <g
                                                        id="SvgjsG5032"
                                                        className="apexcharts-series apexcharts-pie-series"
                                                        seriesname="Player"
                                                        rel={1}
                                                        data:realindex={0}
                                                      >
                                                        <path
                                                          id="SvgjsPath5033"
                                                          d="M 111.5 8.719512195121936 A 102.78048780487806 102.78048780487806 0 0 1 130.75914291864012 212.45996279440718 L 111.5 111.5 L 111.5 8.719512195121936"
                                                          fill="rgba(8,108,184,1)"
                                                          fillOpacity={1}
                                                          strokeOpacity={1}
                                                          strokeLinecap="butt"
                                                          strokeWidth="1.217142857142857"
                                                          strokeDasharray={0}
                                                          className="apexcharts-pie-area apexcharts-pie-slice-0"
                                                          index={0}
                                                          j={0}
                                                          data:angle="169.2"
                                                          data:startangle={0}
                                                          data:strokewidth={2}
                                                          data:value={47}
                                                          data:pathorig="M 111.5 8.719512195121936 A 102.78048780487806 102.78048780487806 0 0 1 130.75914291864012 212.45996279440718 L 111.5 111.5 L 111.5 8.719512195121936"
                                                          stroke="#ffffff"
                                                        />
                                                      </g>
                                                      <g
                                                        id="SvgjsG5045"
                                                        className="apexcharts-series apexcharts-pie-series"
                                                        seriesname="Banker"
                                                        rel={2}
                                                        data:realindex={1}
                                                      >
                                                        <path
                                                          id="SvgjsPath5046"
                                                          d="M 130.75914291864012 212.45996279440718 A 102.78048780487806 102.78048780487806 0 0 1 45.98525139509803 32.306273047385986 L 111.5 111.5 L 130.75914291864012 212.45996279440718"
                                                          fill="rgba(174,33,48,1)"
                                                          fillOpacity={1}
                                                          strokeOpacity={1}
                                                          strokeLinecap="butt"
                                                          strokeWidth="1.217142857142857"
                                                          strokeDasharray={0}
                                                          className="apexcharts-pie-area apexcharts-pie-slice-1"
                                                          index={0}
                                                          j={1}
                                                          data:angle="151.2"
                                                          data:startangle="169.2"
                                                          data:strokewidth={2}
                                                          data:value={42}
                                                          data:pathorig="M 130.75914291864012 212.45996279440718 A 102.78048780487806 102.78048780487806 0 0 1 45.98525139509803 32.306273047385986 L 111.5 111.5 L 130.75914291864012 212.45996279440718"
                                                          stroke="#ffffff"
                                                        />
                                                      </g>
                                                      <g
                                                        id="SvgjsG5058"
                                                        className="apexcharts-series apexcharts-pie-series"
                                                        seriesname="Tie"
                                                        rel={3}
                                                        data:realindex={2}
                                                      >
                                                        <path
                                                          id="SvgjsPath5059"
                                                          d="M 45.98525139509803 32.306273047385986 A 102.78048780487806 102.78048780487806 0 0 1 111.48206142090105 8.719513760558272 L 111.5 111.5 L 45.98525139509803 32.306273047385986"
                                                          fill="rgba(39,149,50,1)"
                                                          fillOpacity={1}
                                                          strokeOpacity={1}
                                                          strokeLinecap="butt"
                                                          strokeWidth="1.217142857142857"
                                                          strokeDasharray={0}
                                                          className="apexcharts-pie-area apexcharts-pie-slice-2"
                                                          index={0}
                                                          j={2}
                                                          data:angle="39.60000000000002"
                                                          data:startangle="320.4"
                                                          data:strokewidth={2}
                                                          data:value={11}
                                                          data:pathorig="M 45.98525139509803 32.306273047385986 A 102.78048780487806 102.78048780487806 0 0 1 111.48206142090105 8.719513760558272 L 111.5 111.5 L 45.98525139509803 32.306273047385986"
                                                          stroke="#ffffff"
                                                        />
                                                      </g>
                                                      <g
                                                        id="SvgjsG5034"
                                                        className="apexcharts-datalabels"
                                                      >
                                                        <text
                                                          id="SvgjsText5035"
                                                          fontFamily="Helvetica, Arial, sans-serif"
                                                          x="193.35947548950986"
                                                          y="103.76200132050303"
                                                          textAnchor="middle"
                                                          dominantBaseline="auto"
                                                          fontSize="10px"
                                                          fontWeight={600}
                                                          fill="#ffffff"
                                                          className="apexcharts-text apexcharts-pie-label"
                                                          filter="url(#SvgjsFilter5036)"
                                                          style={{
                                                            fontFamily:
                                                              "Helvetica, Arial, sans-serif",
                                                          }}
                                                        >
                                                          47.0%
                                                        </text>
                                                      </g>
                                                      <g
                                                        id="SvgjsG5047"
                                                        className="apexcharts-datalabels"
                                                      >
                                                        <text
                                                          id="SvgjsText5048"
                                                          fontFamily="Helvetica, Arial, sans-serif"
                                                          x="37.101147334794035"
                                                          y="146.50944262741888"
                                                          textAnchor="middle"
                                                          dominantBaseline="auto"
                                                          fontSize="10px"
                                                          fontWeight={600}
                                                          fill="#ffffff"
                                                          className="apexcharts-text apexcharts-pie-label"
                                                          filter="url(#SvgjsFilter5049)"
                                                          style={{
                                                            fontFamily:
                                                              "Helvetica, Arial, sans-serif",
                                                          }}
                                                        >
                                                          42.0%
                                                        </text>
                                                      </g>
                                                      <g
                                                        id="SvgjsG5060"
                                                        className="apexcharts-datalabels"
                                                      >
                                                        <text
                                                          id="SvgjsText5061"
                                                          fontFamily="Helvetica, Arial, sans-serif"
                                                          x="83.64748105534319"
                                                          y="34.13665248052477"
                                                          textAnchor="middle"
                                                          dominantBaseline="auto"
                                                          fontSize="10px"
                                                          fontWeight={600}
                                                          fill="#ffffff"
                                                          className="apexcharts-text apexcharts-pie-label"
                                                          filter="url(#SvgjsFilter5062)"
                                                          style={{
                                                            fontFamily:
                                                              "Helvetica, Arial, sans-serif",
                                                          }}
                                                        >
                                                          11.0%
                                                        </text>
                                                      </g>
                                                    </g>
                                                  </g>
                                                </g>
                                                <line
                                                  id="SvgjsLine5071"
                                                  x1={0}
                                                  y1={0}
                                                  x2={223}
                                                  y2={0}
                                                  stroke="#b6b6b6"
                                                  strokeDasharray={0}
                                                  strokeWidth={1}
                                                  strokeLinecap="butt"
                                                  className="apexcharts-ycrosshairs"
                                                />
                                                <line
                                                  id="SvgjsLine5072"
                                                  x1={0}
                                                  y1={0}
                                                  x2={223}
                                                  y2={0}
                                                  strokeDasharray={0}
                                                  strokeWidth={0}
                                                  strokeLinecap="butt"
                                                  className="apexcharts-ycrosshairs-hidden"
                                                />
                                              </g>
                                            </svg>
                                            <div className="apexcharts-tooltip apexcharts-theme-dark">
                                              <div
                                                className="apexcharts-tooltip-series-group"
                                                style={{ order: 1 }}
                                              >
                                                <span
                                                  className="apexcharts-tooltip-marker"
                                                  style={{
                                                    backgroundColor:
                                                      "rgb(8, 108, 184)",
                                                  }}
                                                />
                                                <div
                                                  className="apexcharts-tooltip-text"
                                                  style={{
                                                    fontFamily:
                                                      "Helvetica, Arial, sans-serif",
                                                    fontSize: "12px",
                                                  }}
                                                >
                                                  <div className="apexcharts-tooltip-y-group">
                                                    <span className="apexcharts-tooltip-text-y-label" />
                                                    <span className="apexcharts-tooltip-text-y-value" />
                                                  </div>
                                                  <div className="apexcharts-tooltip-goals-group">
                                                    <span className="apexcharts-tooltip-text-goals-label" />
                                                    <span className="apexcharts-tooltip-text-goals-value" />
                                                  </div>
                                                  <div className="apexcharts-tooltip-z-group">
                                                    <span className="apexcharts-tooltip-text-z-label" />
                                                    <span className="apexcharts-tooltip-text-z-value" />
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                className="apexcharts-tooltip-series-group"
                                                style={{ order: 2 }}
                                              >
                                                <span
                                                  className="apexcharts-tooltip-marker"
                                                  style={{
                                                    backgroundColor:
                                                      "rgb(174, 33, 48)",
                                                  }}
                                                />
                                                <div
                                                  className="apexcharts-tooltip-text"
                                                  style={{
                                                    fontFamily:
                                                      "Helvetica, Arial, sans-serif",
                                                    fontSize: "12px",
                                                  }}
                                                >
                                                  <div className="apexcharts-tooltip-y-group">
                                                    <span className="apexcharts-tooltip-text-y-label" />
                                                    <span className="apexcharts-tooltip-text-y-value" />
                                                  </div>
                                                  <div className="apexcharts-tooltip-goals-group">
                                                    <span className="apexcharts-tooltip-text-goals-label" />
                                                    <span className="apexcharts-tooltip-text-goals-value" />
                                                  </div>
                                                  <div className="apexcharts-tooltip-z-group">
                                                    <span className="apexcharts-tooltip-text-z-label" />
                                                    <span className="apexcharts-tooltip-text-z-value" />
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                className="apexcharts-tooltip-series-group"
                                                style={{ order: 3 }}
                                              >
                                                <span
                                                  className="apexcharts-tooltip-marker"
                                                  style={{
                                                    backgroundColor:
                                                      "rgb(39, 149, 50)",
                                                  }}
                                                />
                                                <div
                                                  className="apexcharts-tooltip-text"
                                                  style={{
                                                    fontFamily:
                                                      "Helvetica, Arial, sans-serif",
                                                    fontSize: "12px",
                                                  }}
                                                >
                                                  <div className="apexcharts-tooltip-y-group">
                                                    <span className="apexcharts-tooltip-text-y-label" />
                                                    <span className="apexcharts-tooltip-text-y-value" />
                                                  </div>
                                                  <div className="apexcharts-tooltip-goals-group">
                                                    <span className="apexcharts-tooltip-text-goals-label" />
                                                    <span className="apexcharts-tooltip-text-goals-value" />
                                                  </div>
                                                  <div className="apexcharts-tooltip-z-group">
                                                    <span className="apexcharts-tooltip-text-z-label" />
                                                    <span className="apexcharts-tooltip-text-z-value" />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </apx-chart> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mobile-graph d-lg-none d-block w-100">
                        <div className="baccarat-graph text-center w-100">
                          <div className="baccrat-graph-header">
                            <span>Statistics</span>
                            <i className="fa-chevron-down fas" /> Click here for
                            close statistics{" "}
                          </div>
                        </div>
                      </div>
                    </app-pie-chart>
                    <div className="baccarat-odds-container ng-tns-c3502172659-7">
                      <div className="baccarat-other-odds ng-tns-c3502172659-7">
                        {reqRes?.data?.data?.t2[5]?.gstatus == 0 ? (
                          <div className="baccarat-other-odd-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              className={`ng-tns-c3502172659-7 baccarat-other-odd-box suspended-box`}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Score 1-4{" "}
                                </span>
                                <span className="ng-tns-c3502172659-7">
                                  <i className="fa fa-lock" />
                                </span>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {" "}
                              0.00{" "}
                            </div>
                          </div>
                        ) : (
                          <div className="baccarat-other-odd-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              onClick={() => {
                                handleModal(
                                  reqRes?.data?.data?.t2[5]?.b1,
                                  reqRes?.data?.data?.t2[5]?.nat,
                                  1
                                );
                                setBetIndex(reqRes?.data?.data?.t2[5]?.sid);
                              }}
                              className={`ng-tns-c3502172659-7 baccarat-other-odd-box`}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Score 1-4
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  {reqRes?.data?.data?.t2[5]?.b1}
                                  {/* {getOddForEntity(
                                    "Score 1-4",
                                    casinoData
                                  )} */}
                                  {/* <span className="ng-tns-c3502172659-7 ng-star-inserted">
                                      :1
                                    </span> */}
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {thirtyTwoCardStack.map(
                                (ele) =>
                                  ele.number === 1 && (
                                    <span
                                      style={{
                                        color:
                                          ele.amount >= 0 ? "green" : "red",
                                      }}
                                    >
                                      {ele.number == 1 && ele.amount}
                                    </span>
                                  )
                              )}
                            </div>
                          </div>
                        )}

                        {reqRes?.data?.data?.t2[6]?.gstatus == 0 ? (
                          <div className="baccarat-other-odd-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              className={`ng-tns-c3502172659-7 baccarat-other-odd-box suspended-box`}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Score 5-6{" "}
                                </span>
                                <span className="ng-tns-c3502172659-7">
                                  <i className="fa fa-lock" />
                                </span>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {" "}
                              0.00{" "}
                            </div>
                          </div>
                        ) : (
                          <div className="baccarat-other-odd-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              onClick={() => {
                                handleModal(
                                  reqRes?.data?.data?.t2[6]?.b1,
                                  reqRes?.data?.data?.t2[6]?.nat,
                                  2
                                );
                                setBetIndex(reqRes?.data?.data?.t2[6]?.sid);
                              }}
                              className={`ng-tns-c3502172659-7 baccarat-other-odd-box`}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Score 5-6
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  {reqRes?.data?.data?.t2[6]?.b1}
                                  {/* {getOddForEntity(
                                    "Score 1-4",
                                    casinoData
                                  )} */}
                                  {/* <span className="ng-tns-c3502172659-7 ng-star-inserted">
                                      :1
                                    </span> */}
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {thirtyTwoCardStack.map(
                                (ele) =>
                                  ele.number === 2 && (
                                    <span
                                      style={{
                                        color:
                                          ele.amount >= 0 ? "green" : "red",
                                      }}
                                    >
                                      {ele.number == 2 && ele.amount}
                                    </span>
                                  )
                              )}
                            </div>
                          </div>
                        )}

                        {reqRes?.data?.data?.t2[7]?.gstatus == 0 ? (
                          <div className="baccarat-other-odd-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              className={`ng-tns-c3502172659-7 baccarat-other-odd-box suspended-box`}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Score 7{" "}
                                </span>
                                <span className="ng-tns-c3502172659-7">
                                  <i className="fa fa-lock" />
                                </span>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {" "}
                              0.00{" "}
                            </div>
                          </div>
                        ) : (
                          <div className="baccarat-other-odd-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              onClick={() => {
                                handleModal(
                                  reqRes?.data?.data?.t2[7]?.b1,
                                  reqRes?.data?.data?.t2[7]?.nat,
                                  3
                                );
                                setBetIndex(reqRes?.data?.data?.t2[7]?.sid);
                              }}
                              className={`ng-tns-c3502172659-7 baccarat-other-odd-box`}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Score 7
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  {reqRes?.data?.data?.t2[7]?.b1}
                                  {/* {getOddForEntity(
                                    "Score 1-4",
                                    casinoData
                                  )} */}
                                  {/* <span className="ng-tns-c3502172659-7 ng-star-inserted">
                                      :1
                                    </span> */}
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {thirtyTwoCardStack.map(
                                (ele) =>
                                  ele.number === 3 && (
                                    <span
                                      style={{
                                        color:
                                          ele.amount >= 0 ? "green" : "red",
                                      }}
                                    >
                                      {ele.number == 3 && ele.amount}
                                    </span>
                                  )
                              )}
                            </div>
                          </div>
                        )}

                        {reqRes?.data?.data?.t2[8]?.gstatus == 0 ? (
                          <div className="baccarat-other-odd-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              className={`ng-tns-c3502172659-7 baccarat-other-odd-box suspended-box`}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Score 8{" "}
                                </span>
                                <span className="ng-tns-c3502172659-7">
                                  <i className="fa fa-lock" />
                                </span>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {" "}
                              0.00{" "}
                            </div>
                          </div>
                        ) : (
                          <div className="baccarat-other-odd-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              onClick={() => {
                                handleModal(
                                  reqRes?.data?.data?.t2[8]?.b1,
                                  reqRes?.data?.data?.t2[8]?.nat,
                                  4
                                );
                                setBetIndex(reqRes?.data?.data?.t2[8]?.sid);
                              }}
                              className={`ng-tns-c3502172659-7 baccarat-other-odd-box`}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Score 8
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  {reqRes?.data?.data?.t2[8]?.b1}
                                  {/* {getOddForEntity(
                                    "Score 1-4",
                                    casinoData
                                  )} */}
                                  {/* <span className="ng-tns-c3502172659-7 ng-star-inserted">
                                      :1
                                    </span> */}
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {thirtyTwoCardStack.map(
                                (ele) =>
                                  ele.number === 4 && (
                                    <span
                                      style={{
                                        color:
                                          ele.amount >= 0 ? "green" : "red",
                                      }}
                                    >
                                      {ele.number == 4 && ele.amount}
                                    </span>
                                  )
                              )}
                            </div>
                          </div>
                        )}

                        {reqRes?.data?.data?.t2[9]?.gstatus == 0 ? (
                          <div className="baccarat-other-odd-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              className={`ng-tns-c3502172659-7 baccarat-other-odd-box suspended-box`}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Score 9{" "}
                                </span>
                                <span className="ng-tns-c3502172659-7">
                                  <i className="fa fa-lock" />
                                </span>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {" "}
                              0.00{" "}
                            </div>
                          </div>
                        ) : (
                          <div className="baccarat-other-odd-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              onClick={() => {
                                handleModal(
                                  reqRes?.data?.data?.t2[9]?.b1,
                                  reqRes?.data?.data?.t2[9]?.nat,
                                  5
                                );
                                setBetIndex(reqRes?.data?.data?.t2[9]?.sid);
                              }}
                              className={`ng-tns-c3502172659-7 baccarat-other-odd-box`}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Score 9
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  {reqRes?.data?.data?.t2[9]?.b1}
                                  {/* {getOddForEntity(
                                    "Score 1-4",
                                    casinoData
                                  )} */}
                                  {/* <span className="ng-tns-c3502172659-7 ng-star-inserted">
                                      :1
                                    </span> */}
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {thirtyTwoCardStack.map(
                                (ele) =>
                                  ele.number === 5 && (
                                    <span
                                      style={{
                                        color:
                                          ele.amount >= 0 ? "green" : "red",
                                      }}
                                    >
                                      {ele.number == 5 && ele.amount}
                                    </span>
                                  )
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="baccarat-main-odds mt-3 ng-tns-c3502172659-7">
                        {reqRes?.data?.data?.t2[3]?.gstatus == 0 ? (
                          <div className="player-pair-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              className={`ng-tns-c3502172659-7 player-pair-box suspended-box `}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Player Pair{" "}
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  <i className="fa fa-lock" />
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {" "}
                              0.00{" "}
                            </div>
                          </div>
                        ) : (
                          <div className="player-pair-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              onClick={() => {
                                handleModal(
                                  reqRes?.data?.data?.t2[3]?.b1,
                                  reqRes?.data?.data?.t2[3]?.nat,
                                  6
                                );
                                setBetIndex(reqRes?.data?.data?.t2[3]?.sid);
                              }}
                              className={`ng-tns-c3502172659-7 player-pair-box `}

                              // className={` ng-tns-c3502172659-7 baccarat-other-odd-box`}
                              // className="player-pair-box-container ng-tns-c3502172659-7 ng-star-inserted"
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Player Pair
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  {reqRes?.data?.data?.t2[3]?.b1}
                                  {/* {getOddForEntity(
                                    "Score 1-4",
                                    casinoData
                                  )} */}
                                  {/* <span className="ng-tns-c3502172659-7 ng-star-inserted">
                                      :1
                                    </span> */}
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {thirtyTwoCardStack.map(
                                (ele) =>
                                  ele.number === 6 && (
                                    <span
                                      style={{
                                        color:
                                          ele.amount >= 0 ? "green" : "red",
                                      }}
                                    >
                                      {ele.number == 6 && ele.amount}
                                    </span>
                                  )
                              )}
                            </div>
                          </div>
                        )}

                        {reqRes?.data?.data?.t2[0]?.gstatus == 0 ? (
                          <div className="player-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              className={`ng-tns-c3502172659-7 player-box suspended-box `}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Player{" "}
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  <i className="fa fa-lock" />
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {" "}
                              0.00{" "}
                            </div>
                          </div>
                        ) : (
                          <div className="player-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              onClick={() => {
                                handleModal(
                                  reqRes?.data?.data?.t2[0]?.b1,
                                  reqRes?.data?.data?.t2[0]?.nat,
                                  7
                                );
                                setBetIndex(reqRes?.data?.data?.t2[0]?.sid);
                              }}
                              className={`ng-tns-c3502172659-7 player-box `}

                              // className={` ng-tns-c3502172659-7 baccarat-other-odd-box`}
                              // className="player-pair-box-container ng-tns-c3502172659-7 ng-star-inserted"
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Player
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  {reqRes?.data?.data?.t2[0]?.b1}
                                  {/* {getOddForEntity(
                                    "Score 1-4",
                                    casinoData
                                  )} */}
                                  {/* <span className="ng-tns-c3502172659-7 ng-star-inserted">
                                      :1
                                    </span> */}
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {thirtyTwoCardStack.map(
                                (ele) =>
                                  ele.number === 7 && (
                                    <span
                                      style={{
                                        color:
                                          ele.amount >= 0 ? "green" : "red",
                                      }}
                                    >
                                      {ele.number == 7 && ele.amount}
                                    </span>
                                  )
                              )}
                            </div>
                          </div>
                        )}

                        {reqRes?.data?.data?.t2[2]?.gstatus == 0 ? (
                          <div className="tie-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              className={`ng-tns-c3502172659-7 tie-box suspended-box `}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Tie{" "}
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  <i className="fa fa-lock" />
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {" "}
                              0.00{" "}
                            </div>
                          </div>
                        ) : (
                          <div className="tie-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              onClick={() => {
                                handleModal(
                                  reqRes?.data?.data?.t2[2]?.b1,
                                  reqRes?.data?.data?.t2[2]?.nat,
                                  8
                                );
                                setBetIndex(reqRes?.data?.data?.t2[2]?.sid);
                              }}
                              className={`ng-tns-c3502172659-7 tie-box `}

                              // className={` ng-tns-c3502172659-7 baccarat-other-odd-box`}
                              // className="player-pair-box-container ng-tns-c3502172659-7 ng-star-inserted"
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Tie
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  {reqRes?.data?.data?.t2[2]?.b1}
                                  {/* {getOddForEntity(
                                    "Score 1-4",
                                    casinoData
                                  )} */}
                                  {/* <span className="ng-tns-c3502172659-7 ng-star-inserted">
                                      :1
                                    </span> */}
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {thirtyTwoCardStack.map(
                                (ele) =>
                                  ele.number === 8 && (
                                    <span
                                      style={{
                                        color:
                                          ele.amount >= 0 ? "green" : "red",
                                      }}
                                    >
                                      {ele.number == 8 && ele.amount}
                                    </span>
                                  )
                              )}
                            </div>
                          </div>
                        )}

                        {reqRes?.data?.data?.t2[1]?.gstatus == 0 ? (
                          <div className="banker-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              className={`ng-tns-c3502172659-7 banker-box suspended-box `}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Banker{" "}
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  <i className="fa fa-lock" />
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {" "}
                              0.00{" "}
                            </div>
                          </div>
                        ) : (
                          <div className="banker-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              onClick={() => {
                                handleModal(
                                  reqRes?.data?.data?.t2[1]?.b1,
                                  reqRes?.data?.data?.t2[1]?.nat,
                                  9
                                );
                                setBetIndex(reqRes?.data?.data?.t2[1]?.sid);
                              }}
                              className={`ng-tns-c3502172659-7 banker-box `}

                              // className={` ng-tns-c3502172659-7 baccarat-other-odd-box`}
                              // className="player-pair-box-container ng-tns-c3502172659-7 ng-star-inserted"
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Banker
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  {reqRes?.data?.data?.t2[1]?.b1}
                                  {/* {getOddForEntity(
                                    "Score 1-4",
                                    casinoData
                                  )} */}
                                  {/* <span className="ng-tns-c3502172659-7 ng-star-inserted">
                                      :1
                                    </span> */}
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {thirtyTwoCardStack.map(
                                (ele) =>
                                  ele.number === 9 && (
                                    <span
                                      style={{
                                        color:
                                          ele.amount >= 0 ? "green" : "red",
                                      }}
                                    >
                                      {ele.number == 9 && ele.amount}
                                    </span>
                                  )
                              )}
                            </div>
                          </div>
                        )}
                        {reqRes?.data?.data?.t2[4]?.gstatus == 0 ? (
                          <div className="banker-pair-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              className={`ng-tns-c3502172659-7  banker-pair-box suspended-box `}
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Banker Pair{" "}
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  <i className="fa fa-lock" />
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {" "}
                              0.00{" "}
                            </div>
                          </div>
                        ) : (
                          <div className="banker-pair-box-container ng-tns-c3502172659-7 ng-star-inserted">
                            <div
                              onClick={() => {
                                handleModal(
                                  reqRes?.data?.data?.t2[4]?.b1,
                                  reqRes?.data?.data?.t2[4]?.nat,
                                  10
                                );
                                setBetIndex(reqRes?.data?.data?.t2[4]?.sid);
                              }}
                              className={`ng-tns-c3502172659-7 banker-pair-box `}

                              // className={` ng-tns-c3502172659-7 baccarat-other-odd-box`}
                              // className="player-pair-box-container ng-tns-c3502172659-7 ng-star-inserted"
                            >
                              <span className="ng-tns-c3502172659-7">
                                <span className="ng-tns-c3502172659-7">
                                  Banker Pair
                                </span>
                                <div className="ng-tns-c3502172659-7">
                                  {reqRes?.data?.data?.t2[4]?.b1}
                                  {/* {getOddForEntity(
                                    "Score 1-4",
                                    casinoData
                                  )} */}
                                  {/* <span className="ng-tns-c3502172659-7 ng-star-inserted">
                                      :1
                                    </span> */}
                                </div>
                              </span>
                            </div>
                            <div className="casino-nation-book text-center ng-tns-c3502172659-7 text-success">
                              {thirtyTwoCardStack.map(
                                (ele) =>
                                  ele.number === 10 && (
                                    <span
                                      style={{
                                        color:
                                          ele.amount >= 0 ? "green" : "red",
                                      }}
                                    >
                                      {ele.number == 10 && ele.amount}
                                    </span>
                                  )
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="min-max ng-tns-c3502172659-7">
                        <p className="ng-tns-c3502172659-7">
                          Min: 100 Max: 300000
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="ng-tns-c3502172659-7">
                <div className="casino-last-result-title ng-tns-c3502172659-7">
                  <span className="ng-tns-c3502172659-7">Last Result</span>
                  <span className="ng-tns-c3502172659-7">
                    <a className="ng-tns-c3502172659-7">View All</a>
                  </span>
                </div>
                <div className="casino-last-results ng-tns-c3502172659-7 ng-star-inserted" >
                    {results?.data?.result?.map((result, index) => {
                      const buttonValue = reqRes?.data?.data?.t2.find(
                        (item) => item.sid === result?.result
                      );
                      const getColor = (resultValue) => {
                        switch (resultValue) {
                          case "1":
                            return "#08c";
                          case "3":
                            return "#279532";
                          case "2":
                            return "#ae2130";
                          default:
                            return "inherit"; // Default color if no match
                        }
                      };
                      return (
                        <span
                        style={{ backgroundColor: getColor(result?.result) }}
                          className="ng-tns-c3502172659-7 result result-b ng-star-inserted"
                          key={index}
                        >
                          <span
                            className="ng-tns-c3502172659-7"
                            onClick={() => {
                              setMidRound(result.mid);
                              CasinoGameResult_API(result.mid);
                              setShowresultModal(true);
                              // setTrophy(buttonValue.nation[0]);

                            }}
                          >
                            {buttonValue && <>{buttonValue.nat[0]}</>}
                            {/* {buttonValue ? <>{buttonValue?.nation[0]}</> : "T"} */}
                          </span>
                        </span>
                      );
                    })}
                  </div>
              </div>
            </div>
          </div>
          ) : ( 
            <CasinoPlacedBet bets={history} />
           )} 

        </div>
      </div>
      <CasinoBetModal
        id={id}
        name={name}
        modalOpen={showModal}
        betDetails={betDetails}
        setbetDetails={setbetDetails}
        setShowModal={setShowModal}
        betHistory={history}
        realTime={realTime}
        setRealTimeData={setRealTimeData}
      />
    </div>
  );
}
